<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.gamification_sets', 2),
                        href: meta.links.set_index,
                    },
                    {
                        name: gamificationSet.breadcrumb_title,
                        href: meta.links.set_show,
                    },
                    {
                        name: $tc('messages.gamification_rewards', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $tc('messages.images', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="mt-3">
            <Dashboard :uppy="uppy" :plugins="['Webcam']" :props="{ theme: 'light' }" />
        </div>

        <div class="md:grid md:grid-cols-3 xl:grid-cols-6 md:gap-6">
            <div class="flex flex-col w-40" v-for="image in options.images" :key="image.id">
                <div class="mt-2">
                    <div
                        class="bg-indigo-500 shrink-0 flex items-center justify-center h-16 w-full rounded-lg aspect-w-1 aspect-h-1"
                    >
                        <img v-if="image.full_path" :src="image.full_path" alt="" />
                    </div>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import { Dashboard } from '@uppy/vue';
import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';
import Spanish from '@uppy/locales/lib/es_ES';
import XHRUpload from '@uppy/xhr-upload';
import Uppy from '@uppy/core';

export default {
    components: {
        PanelPage,
        Dashboard,
    },
    layout: Layout,
    name: 'Edit',
    props: ['meta', 'options', 'reward', 'gamificationSet'],
    computed: {
        uppy: function () {
            const config = {
                autoProceed: false,
                restrictions: {
                    maxFileSize: 20000000,
                    maxNumberOfFiles: 500,
                    allowedFileTypes: ['image/*', '.jpg', '.jpeg', '.png'],
                },
            };
            if (['es', 'ca'].includes(this.getLocale())) {
                config.locale = Spanish;
            }

            return new Uppy(config)
                .use(XHRUpload, {
                    endpoint: this.meta.links.store,
                    method: 'POST',
                    formData: true,
                    fieldName: 'image',
                    headers: {
                        'X-CSRF-TOKEN': this.$page.props.csrf_token,
                    },
                })
                .on('complete', (result) => {
                    if (result.failed.length === 0) {
                        this.$inertia.reload();
                    }
                });
        },
    },
    beforeUnmount() {
        this.uppy.close({ reason: 'unmount' });
    },
    methods: {
        getLocale() {
            return this.$i18n.locale;
        },
    },
};
</script>
